export const foods: FoodsSetup = {
    // Events
    bread1: { type: 'bread1', calories: 800, x: 30, y: 29 },
    bread2: { type: 'bread2', calories: 2000 },
    bread3: { type: 'bread2', calories: 2500, x: 0, y: 30, size: 1.5 },
    bread4: { type: 'bread2', calories: 500 },
    cake: { type: 'cake', calories: 40000, size: 3, x: 18, y: 33 },
    cheese: { type: 'cheese', size: 6, x: 47, y: 47 },
    redgrapes: { type: 'redgrapes', calories: 1500, x: 25, y: 42, size: 1.5 },
    //applepie: { type: 'applepie', calories: 40000, x: 24, y: 48, size: 3 },    
    //watermelon: { type: 'watermelon', calories: 8000, x: 1, y: 48, size: 3 },

    random: [
        // Small
        { type: 'acorn', calories: 1000, x: 6, y: 8, size: 0.5 },
        { type: 'acorn', calories: 1000, x: 26, y: 1, size: 0.5 },
        { type: 'acorn', calories: 1000, x: 43, y: 21, size: 0.5 },
        { type: 'mushroom', calories: 1000, x: 23, y: 28, size: 0.5 },
        { type: 'mushroom', calories: 1000, x: 41, y: 29, size: 0.5 },
        { type: 'carrot', calories: 1000, x: 10, y: 27, size: 1 },
        { type: 'carrot', calories: 1000, x: 32, y: 29, size: 1 },
        { type: 'cherry', calories: 1600, x: 16, y: 5, size: 1 },
        { type: 'cherry', calories: 800, x: 35, y: 36, size: 1 },
        { type: 'cherry', calories: 800, x: 43, y: 39, size: 1 },
        { type: 'apple', calories: 1600, x: 17, y: 12, size: 1 },
        { type: 'apple', calories: 1600, x: 33, y: 20, size: 1 },
        // Big
        { type: 'redgrapes', calories: 1500, x: 36, y: 6, size: 1.5 },
        { type: 'bread1', calories: 2500, x: 7, y: 20, size: 1.5 },
        { type: 'bread1', calories: 2500, x: 30, y: 10, size: 1.5 },
        { type: 'bread2', calories: 2500, x: 31, y: 43, size: 1.5 },
        { type: 'corn', calories: 4000, x: 40, y: 14, size: 2 },
        { type: 'corn', calories: 4000, x: 47, y: 5, size: 2 },
        { type: 'donuts', calories: 6000, x: 5, y: 2, size: 2 },
        { type: 'donuts', calories: 6000, x: 45, y: 2, size: 2 },
        { type: 'watermelon', calories: 5000, x: 48, y: 2, size: 3 }
    ],
};